import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadingDialogProps {
  open: boolean;
  title?: string;
  description?: string;
}

export const LoadingDialog: React.FC<LoadingDialogProps> = ({
  open,
  title = 'Đang tải...',
  description = 'Vui lòng chờ trong giây lát',
}) => {
  return (
    <Dialog open={open} modal>
      <DialogContent 
        className="sm:max-w-md [&>button]:hidden" 
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-center">{title}</DialogTitle>
          {description && (
            <DialogDescription className="text-center">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="flex justify-center py-6">
          <LoadingSpinner />
        </div>
      </DialogContent>
    </Dialog>
  );
};